import React from 'react';
import Section from './Section';
import SafeIcon from '../common/SafeIcon';
import { FiShield } from 'react-icons/fi';

const CaseStudy = () => {
  return (
    <div id="example" className="bg-zinc-100 border-y border-zinc-200">
      <Section>
        <div className="max-w-3xl mx-auto">
          <div className="mb-10">
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4">
              Example Insight
            </h2>
            <p className="text-xl text-zinc-600">
              This is a simplified example of what you'll find in your customized audit report.
            </p>
          </div>

          <div className="bg-white border text-left border-zinc-200 rounded-2xl overflow-hidden shadow-sm">
            <div className="bg-zinc-950 text-white p-4 px-6 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <SafeIcon icon={FiShield} className="text-zinc-400" />
                <span className="font-semibold">Risk Analysis Snippet</span>
              </div>
              <span className="text-xs bg-red-500/20 text-red-400 px-2 py-1 rounded font-medium border border-red-500/30">High Risk</span>
            </div>
            <div className="p-6 md:p-8 space-y-6">
              <div>
                <h4 className="text-sm uppercase tracking-wider font-semibold text-zinc-500 mb-1">Target Application</h4>
                <p className="text-xl font-bold text-zinc-900">TikTok (Social Media)</p>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h4 className="text-sm uppercase tracking-wider font-semibold text-zinc-500 mb-1">Data Collected</h4>
                  <p className="text-zinc-700">Precise location, typing patterns, behavioral rhythms, clipboard contents.</p>
                </div>
                <div>
                  <h4 className="text-sm uppercase tracking-wider font-semibold text-zinc-500 mb-1">Primary Risk</h4>
                  <p className="text-zinc-700">Deep behavioral profiling and targeted psychological influence.</p>
                </div>
              </div>

              <div className="bg-red-50 border border-red-100 p-4 rounded-lg">
                <h4 className="text-sm uppercase tracking-wider font-semibold text-red-800 mb-2">Real-World Impact</h4>
                <p className="text-red-900 font-medium">
                  "Content and algorithmic offers can be hyper-adjusted to exploit emotional states, heavily influencing financial decisions, spending habits, and attention spans without your conscious awareness."
                </p>
              </div>
            </div>
          </div>
          
          <p className="text-center text-zinc-500 mt-6 font-medium">
            Your report includes deep insights like this for all the apps in your personal stack.
          </p>
        </div>
      </Section>
    </div>
  );
};

export default CaseStudy;